import * as Types from '../model/types';
import * as Graph from '../graph';

// Not exposed yet. Needs to handle tags, nulls (see number.ts)

export const opTypeString = Graph.makeOp({
  hidden: true,
  name: 'type-string',
  argTypes: {type: 'type'},
  description: `Returns the ${Graph.docType(
    'string'
  )} representation of a ${Graph.docType('type')}`,
  argDescriptions: {type: `The ${Graph.docType('type')}`},
  returnValueDescription: `The ${Graph.docType(
    'string'
  )} representation of the ${Graph.docType('type')}`,
  returnType: 'string',
  resolver: async (inputs, forwardGraph, forwardOp, context) => {
    return Types.toString(inputs.type);
  },
});
